import * as stylex from '@stylexjs/stylex'

import { colors, controlSizes, fonts, fontSizes, lineHeights, radii, spacing } from '../tokens/tokens.stylex'

export const fieldStyles = stylex.create({
  control: {
    backgroundColor: { default: 'transparent', ':disabled': colors.surfaceAlt },
    borderColor: { default: colors.border, ':is([aria-invalid="true"])': colors.danger },
    borderRadius: radii.small,
    borderStyle: 'solid',
    borderWidth: 1,
    boxSizing: 'border-box',
    color: { default: colors.foreground, ':disabled': colors.muted },
    cursor: { default: 'text', ':disabled': 'not-allowed' },
    fontFamily: fonts.sans,
    fontSize: fontSizes.reading,
    lineHeight: lineHeights.reading,
    minWidth: 0,
    outline: { default: 'none', ':focus-visible': `2px solid ${colors.foreground}` },
    outlineOffset: 2,
    paddingInline: spacing.space12,
    width: '100%',
    '::placeholder': { color: colors.placeholder, opacity: 1 },
  },
  input: { height: controlSizes.field, paddingBlock: 0 },
  textarea: { display: 'block', minHeight: controlSizes.field, paddingBlock: spacing.space8, resize: 'vertical' },
})
